import Fetch from '../fetch'
import ConfigHelper from 'framework/helpers/config'
import DataHelper from 'framework/helpers/data'
import { of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import Constants from 'api-constants'
import { getNagraDeviceType } from '../helpers'

export default class ReportActivityApi extends Fetch {
    _nagraApiUrl = ConfigHelper.getInstance().getConfig('urls').apiUrl

    _getReportUserActivityRequestHeaders() {
        return {
            'Content-Type': Constants.httpHeader.ContentType.APPLICATION_JSON,
            'Client-token': DataHelper.getInstance().getSecondaryAccessToken(),
        }
    }

    _getUserProfileDetails() {
        return {
            accountId: DataHelper.getInstance().getData(DataHelper.STORE_KEY.ACCOUNT_ID),
            deviceId: this.config.uniqueDeviceId,
        }
    }

    static CONTENT_TYPE = {
        LIVE_EVENT: 'live-event', // isLive
        LIVE_STCU_EVENT: 'live-stcu-event', // short term catchup
        VOD_ED: 'vod-ed', // VOD program
        DVR_EVENT: 'npvr-event', // DVR program
    }

    static REPORT_EVENT_TYPE = {
        PLAYBACK_START: 'playbackStart',
        PLAYBACK_STOP: 'playbackStop',
        PLAYBACK_PAUSE: 'playbackPause',
        PLAYBACK_SKIP_AHEAD: 'playbackSkipAhead',
        PLAYBACK_SKIP_BACK: 'playbackSkipBack',
    }

    /**
     * @param {ReportActivityApi.CONTENT_TYPE} contentType - the type of the content
     */
    set setContentType(contentType) {
        this._contentType = contentType
    }

    /**
     * @param {String} contentId - the ID of the content being watched
     */
    set setContentId(contentId) {
        this._contentId = contentId
    }

    /**
     * Sends user activity report request
     * @param {PlayerApi.REPORT_EVENT_TYPE} eventType - the type the reporting event
     * @returns {Observable<Boolean>} returns true if the request was successful
     */
    sendUserActivityReportRequest(eventType) {
        const { accountId, deviceId } = this._getUserProfileDetails()

        this.logger.info(`[REPORT USER ACTIVITY] sending request for "${eventType}" event...`)
        if (!this._contentId || !this._contentType) {
            this.logger.error('[REPORT USER ACTIVITY] empty contentId or contentType.')
            return of(false)
        }
        let body
        switch (this._contentType) {
            case ReportActivityApi.CONTENT_TYPE.LIVE_EVENT:
            case ReportActivityApi.CONTENT_TYPE.LIVE_STCU_EVENT:
                body = {
                    accountId,
                    deviceId,
                    name: eventType,
                    key: '',
                    metadata: {
                        contentType: this._contentType,
                        programmeId: this._contentId,
                        deviceType: getNagraDeviceType(this.config.platform),
                    },
                }
                break
            case ReportActivityApi.CONTENT_TYPE.VOD_ED:
                body = {
                    accountId,
                    deviceId,
                    name: eventType,
                    key: '',
                    metadata: {
                        contentType: this._contentType,
                        technicalId: this._contentId,
                        deviceType: getNagraDeviceType(this.config.platform),
                    },
                }
                break
            case ReportActivityApi.CONTENT_TYPE.DVR_EVENT:
                body = {
                    accountId,
                    deviceId,
                    name: eventType,
                    key: '',
                    metadata: {
                        contentType: this._contentType,
                        recordingId: this._contentId,
                        deviceType: getNagraDeviceType(this.config.platform),
                    },
                }
                break
            default:
                this.logger.error('[REPORT USER ACTIVITY] INVALID contentType.')
                return of(false)
        }

        return this.fetch({
            url: `${this._nagraApiUrl}/useractivityvault/v1/useractivity/${eventType}`,
            method: 'POST',
            headers: this._getReportUserActivityRequestHeaders(),
            body,
            log: `REPORTING UAV ${eventType}`,
        }).pipe(mergeMap(() => of(true)))
    }
}
